import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: '[mriDatalistTitle]', standalone: true })
export class DatalistItemTitleDirective {
  @HostBinding('class.mri-datalist__item-title') readonly hostClass = true;
  @HostBinding('class.mri-datalist__item-truncated-text') readonly truncatedClass = true;
}
